<template>
	<div class="projects">
		
		<div class="project" :key="project.id" v-for="project in projects">
			<v-card
				:to="`projects/${project.pk}`"
				is-link
				:label="project.status"
			>
				<v-card-title primary-title>
					{{project.name}}
					<v-chip :color="colorForStatus(project.status)">{{project.status}}</v-chip>
				</v-card-title>
			</v-card>
		</div>
		<div v-if="projects.length == 0" class="text-xs-center">
			Keine Projekte verfügbar
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import projectApi from '@/services/projectService';

export default {
  name: "Projects",
  data() {
    return {
      subject: "",
		msgBody: "",
		projects: [],
    };
  },
  created() {
    projectApi.fetchAll().then((projects) => {
		 this.projects = projects
		})
	},
	methods: {
		colorForStatus(status) {
			return {
				"CREATED": "green",
				"ACTIVE": "green",
				"ENDED": "orange",
				"ARCHIVED": "red",
			}[status]
		}
	}
};
</script>

<style>

</style>
